import { Routes } from '@angular/router';
import { Error404Component } from './shared/errors/error404/error404.component';
import { HelpComponent } from './shared/help/help.component';
import { FaqComponent } from './shared/faq/faq.component';
import { PrivacyPolicyComponent } from './shared/privacy-policy/privacy-policy.component';
import { LoginComponent } from './login/login/login.component';

export const APP_ROUTES:Routes=[
    {path:'',redirectTo:'login',pathMatch:'full'},
    {path:'login/:id',component:LoginComponent, data: { title: 'Personal Information Login'}},
    {path:'notFound',component:Error404Component, data: { title: 'Not found'}},
    {path:'help',component:HelpComponent, data: { title: 'Help'}},
    {path:'faq',component:FaqComponent, data: { title: 'Frequently Asked Questions'}},
    {path:'privacy',component:PrivacyPolicyComponent, data: { title: 'Privacy Policy'}},
    {path:'**',redirectTo:'notFound',pathMatch:'prefix'}
  
  ]
  
  
  


// WEBPACK FOOTER //
// ./src/app/app.routes.ts